import {AxiosResponseTransformer} from "axios";
import {
    JSONValue,
    isLosslessNumber,
    LosslessNumber,
    parse,
    stringify,
    parseNumberAndBigInt,
    isInteger
} from "lossless-json";

export function randomString(length: number = 5) {
    return Math.random().toString(36).substr(length);
}

export function generateFileName(prefix: string, fileName: string, separator = '-', length = 5) {
    const nameParts = fileName.split(".")
    const extraName = nameParts.pop()
    const random = randomString(length)
    return `${prefix}${nameParts.join(".")}${separator}${random}.${extraName}`
}

export function Long2String(key: string, value: JSONValue) {
    if (isLosslessNumber(value)) {
        return value.toString().length > 15 ? value.toString() : isInteger(value.toString()) ? parseInt(value.toString()) : parseFloat(value.toString());
    } else {
        return value;
    }
}

export const axiosResponseParser: AxiosResponseTransformer = (data: string, headers: any): any => {
    return parse(data, Long2String)
}
